var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkdin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3653",
    "data-name": "Rectangle 3653",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8823",
    "data-name": "Group 8823",
    transform: "translate(9283 15400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8819",
    "data-name": "Group 8819",
    transform: "translate(-9280 -15400.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8818",
    "data-name": "Group 8818",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M25.014,28.4H3.272c-.025-.088-.105-.058-.161-.071a3.867,3.867,0,0,1-3.04-3.039c-.014-.056.017-.136-.071-.161V3.275c.1-.064.078-.179.1-.27a3.848,3.848,0,0,1,3.714-3q10.382-.011,20.764,0a3.838,3.838,0,0,1,3.816,3.815q.015,10.382,0,20.765a3.835,3.835,0,0,1-2.785,3.655c-.2.057-.4.106-.594.159M15.162,12.611a.4.4,0,0,1-.03-.067c0-.24,0-.48-.007-.72-.01-.429-.207-.633-.628-.635q-1.248-.006-2.5,0a.55.55,0,0,0-.631.627q0,5.309,0,10.619c0,.435.21.639.65.64.767,0,1.534,0,2.3,0,.63,0,.791-.159.791-.78,0-1.784,0-3.567,0-5.351a3.388,3.388,0,0,1,.516-1.868,1.826,1.826,0,0,1,1.945-.818,1.648,1.648,0,0,1,1.393,1.224,5.543,5.543,0,0,1,.207,1.807q0,2.565,0,5.129c0,.459.2.651.665.652q1.248,0,2.5,0c.479,0,.682-.2.682-.668,0-1.959,0-3.919-.01-5.878a9.974,9.974,0,0,0-.268-2.389,3.74,3.74,0,0,0-2.3-2.841A4.864,4.864,0,0,0,18.726,11a3.873,3.873,0,0,0-3.564,1.607m-9.23,4.5q0,2.634,0,5.268a.611.611,0,0,0,.7.7q1.165,0,2.329,0c.491,0,.721-.217.722-.7q0-5.24,0-10.48c0-.492-.22-.706-.715-.709q-1.151-.006-2.3,0c-.528,0-.732.212-.733.744q0,2.592,0,5.185M10.22,7.777A2.418,2.418,0,1,0,7.733,10.16,2.414,2.414,0,0,0,10.22,7.777",
    transform: "translate(0 0)",
    fill: "#998242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3656",
    "data-name": "Rectangle 3656",
    transform: "translate(-9283 -15400)",
    fill: "none",
    stroke: "#998242",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 27,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.e1efdd84119f305173629ff06b8bab0f.svg";
export { ForwardRef as ReactComponent };